<template>
  <div class="err-box">
    <div>
      <h1 class="err-title">Petal</h1>
    </div>
    <div>
      <h3 class="err-msg">
        <b-icon-exclamation-circle></b-icon-exclamation-circle>
        {{$t('text.error')}}:&nbsp;{{errMsg}}
      </h3>
      <p>
        <router-link :to="{name: 'Home'}">{{$t('error.backHome')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Error',
    data() {
        return {
            errCode: '',
            errMsg: ''
        }
    },
    created() {
        this.initErrorMsg()
    },
    methods: {
        initErrorMsg() {
            let message = ''
            if ('message' in this.$route.query) {
                this.errMsg = this.$route.query.message
            }
            if ('referrer_code' in localStorage) {
                this.errCode = localStorage.referrer_code
                message = this.$t(`error.msg${this.errCode}`)
            }
            // set errMsg if find msg corresponding to the errCode in i18n
            if (!/^error.msg\d+/.test(message)) {
                this.errMsg = message
            }
        }
    }
}
</script>
<style scoped>
.err-box{
    margin-top: 240px;
}
.err-title {
    margin-bottom: 30px;
}
.err-msg {
    margin-bottom: 20px;
    font-weight: 800;
    color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue